import _styled from "styled-components";
import { memo } from 'react';
import { CalendarIcon } from '@heroicons/react/24/outline';
import { toDateFormat } from '@restworld/utils-common';
import { CardPrimary, Paragraph } from '../../design-system';
import { useJobPositionDetailsPreview } from './hooks';
/**
 * JobInfoCardPreview - Card con le informazioni principali della job position
 * Versione semplificata senza pulsanti di candidatura e interazioni
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JobInfoCardPreview = /*#__PURE__*/memo(function (_ref) {
  var jobPosition = _ref.jobPosition;

  var _useJobPositionDetail = useJobPositionDetailsPreview(jobPosition),
      jobPositionDetails = _useJobPositionDetail.jobPositionDetails,
      showRestaurant = _useJobPositionDetail.showRestaurant,
      publishedAt = _useJobPositionDetail.publishedAt;

  return /*#__PURE__*/_jsxs(JobInfoWrapper, {
    showRestaurant: showRestaurant || false,
    children: [/*#__PURE__*/_jsx(Wrapper, {
      children: /*#__PURE__*/_jsx(CardPrimary, {
        jobPositionDetails: jobPositionDetails,
        showRestaurant: showRestaurant || false,
        showViolaBadge: false
      })
    }), publishedAt && /*#__PURE__*/_jsx(FooterWrapper, {
      children: /*#__PURE__*/_jsx(JobDetailParagraph, {
        icon: /*#__PURE__*/_jsx(_StyledCalendarIcon, {}),
        children: "Pubblicato il ".concat(toDateFormat(publishedAt, "dd/MM/yyyy"))
      })
    })]
  });
});
JobInfoCardPreview.displayName = 'JobInfoCardPreview';

var JobInfoWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-info-card-preview__JobInfoWrapper",
  componentId: "sc-15p0mud-0"
})(["", " ", " ", " ", " ", ";"], {
  "height": "max-content",
  "width": "100%",
  "borderRadius": "20px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))"
}, {
  "@media (min-width: 1024px)": {
    "minWidth": "384px",
    "maxWidth": "24rem"
  }
}, {
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingBottom": "1.5rem",
  "@media (min-width: 1024px)": {
    "--tw-shadow": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    "--tw-shadow-colored": "0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
  }
}, {
  "@media (min-width: 1024px)": {
    "position": "sticky",
    "top": "0.5rem"
  }
}, function (_ref2) {
  var showRestaurant = _ref2.showRestaurant;
  return showRestaurant ? {
    "paddingTop": "4rem"
  } : {
    "paddingTop": "1.5rem"
  };
});

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-info-card-preview__Wrapper",
  componentId: "sc-15p0mud-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1.5rem",
  "borderBottomWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(196 177 231 / var(--tw-border-opacity))",
  "paddingBottom": "1rem"
});

var FooterWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-info-card-preview__FooterWrapper",
  componentId: "sc-15p0mud-2"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "1rem",
  "paddingTop": "1rem"
});

var JobDetailParagraph = function JobDetailParagraph(_ref3) {
  var children = _ref3.children,
      icon = _ref3.icon;
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [icon, /*#__PURE__*/_jsx(Paragraph, {
      variant: "xsmall",
      color: "white",
      children: children
    })]
  });
};

var _StyledCalendarIcon = /*#__PURE__*/_styled(CalendarIcon).withConfig({
  displayName: "job-info-card-preview___StyledCalendarIcon",
  componentId: "sc-15p0mud-3"
})({
  "height": "13.5px",
  "width": "13.5px",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-info-card-preview___StyledDiv",
  componentId: "sc-15p0mud-4"
})({
  "display": "flex",
  "width": "fit-content",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.5rem"
});